import { Map, List } from 'immutable';
import { actions } from './actions';
import * as lib from './lib';

const initialState = new Map({
  accessToken: '',
  locations: new List(),
  authUser: new Map({ // this is a `User` (not an `AuthUser`) on the Tanda core side
    userId: '',
    name: '',
    userLevels: new List(),
    organisations: new List([
      new Map({
        id: '',
        name: '',
      }),
    ]),
  }),
});

export default function reducer(state = initialState, { type, value }) {
  switch (type) {
    case actions.SET_AUTH_USER:
      return lib.setAuthUser(state, value);
    case actions.SET_ACCESS_TOKEN:
      return lib.setAccessToken(state, value);
    case actions.SET_AUTH_USER_ORGS:
      return lib.setAuthUserOrgs(state, value);
    case actions.SET_LOCATIONS:
      return lib.setLocations(state, value);
    case actions.ADD_LOCATION:
      return lib.addLocation(state, value);
    case actions.CLEAR:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/account/reducer.js